export default "__VITE_ASSET__Dp6Kjkct__"